import Box from '@/common/components/Box'
import Button from '@/common/components/Button'
import useUserPermissions from '@/common/hooks/useUserPermissions'
import AuctionEntryStatus from '@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/components/status/AuctionEntryStatus'
import { AUCTION_VIEW_PERMISSIONS } from '@/features/maintenanceWorkflow/pages/Show/features/establishmentChoiceEntries/features/auction/constants/auctionPermissions.constant'
import { maintenanceForwardingsDirectiveEntryKlasses } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsDirectiveEntryKlasses.constant'
import { MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/types/establishmentChoiceEntries/auctionEntry/auctionEntry.type'
import { useForwardingTabContext } from '@/features/maintenanceWorkflow/pages/Show/hooks/forwardings/useForwardingTabContext'
import { ChevronRightIcon } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

const MaintenanceWorkflowForwardingEstablishmentChoiceEntryAuctionSection = () => {
  const { forwarding, directiveEntryKlass, noActions } = useForwardingTabContext()

  const navigate = useNavigate()

  const { hasUserPermission, isUserPermissionsPending } = useUserPermissions()

  const hasAuctionViewPermissions =
    isUserPermissionsPending || AUCTION_VIEW_PERMISSIONS.every((permission) => hasUserPermission(permission))

  const auctionStatus = forwarding?.establishment_choice_entry
    ?.status as MaintenanceForwardingEstablishmentChoiceEntryAuctionEntryData['status']

  return (
    <Box className="p-4 flex flex-col gap-4">
      <div className="flex items-center gap-2 justify-between">
        <div>
          <p className="text-lg font-semibold">
            Leilão{' '}
            {directiveEntryKlass && `(${maintenanceForwardingsDirectiveEntryKlasses[directiveEntryKlass]?.label})`}
          </p>

          <AuctionEntryStatus status={auctionStatus} />
        </div>

        {!noActions && (
          <div>
            <Button
              onClick={() =>
                navigate(`${forwarding.id}/auction/${forwarding?.establishment_choice_entry?.id}`)
              }
              disabled={!hasAuctionViewPermissions}
              tooltipMessage={hasAuctionViewPermissions ? undefined : 'Você não tem permissão'}
            >
              Visualizar

              <ChevronRightIcon strokeWidth={1.5} size={20} />
            </Button>
          </div>
        )}
      </div>
    </Box>
  )
}

export default MaintenanceWorkflowForwardingEstablishmentChoiceEntryAuctionSection
